const SiteThemeCategory = () =>
  import(
    /* webpackChunkName: "site-generator-theme-category" */ '@/pages/site-generator/base-info/theme-category/index.vue'
  )
const CreateSiteThemeCategory = () =>
  import(
    /* webpackChunkName: "site-generator-theme-category" */ '@/pages/site-generator/base-info/theme-category/create.vue'
  )
const EditSiteThemeCategory = () =>
  import(
    /* webpackChunkName: "site-generator-theme-category" */ '@/pages/site-generator/base-info/theme-category/edit.vue'
  )

export default {
  path: 'theme-category',
  meta: {
    label: 'themeCategory',
    auth: 'themeCategory'
  },
  component: {
    name: 'ThemeCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteThemeCategoryReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: SiteThemeCategory
    },
    {
      name: 'SiteCreateThemeCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSiteThemeCategory
    },
    {
      name: 'SiteEditThemeCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSiteThemeCategory,
      props: true
    }
  ]
}
